import { TextFieldTypes } from '@ionic/core';
import { IonInput, IonItem } from '@ionic/react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../config/utils/formDiffUtils';
import { disableSubmitOnEnter } from '../../../config/utils/formUtils';

interface Props {
  field: any;
  formik: any;
}

export const CustomerSimpleInput = ({ field, formik }: Props) => {
  const { t } = useTranslation();
  const hasError = useMemo(() => showError(formik, formik?.errors?.[field.name]), [formik?.errors?.[field.name]]);

  const getRequiredSign = useCallback(() => {
    if (field.required) return ' *';
  }, [field]);

  return (
    <div>
      <div className="padding-b-16 padding-l-12">
        {t(`FORMS.${field?.label}`)}
        {getRequiredSign()}
      </div>
      <div key={field?.name} className="flex-center-start-column-nowrap positionRelative width-300px">
        <IonItem
          className={`width-300px height-50px border-radius-input g-select-border cursorPointer ${
            hasError && 'b-field-border-error'
          }`}
          mode="md">
          <IonInput
            data-testId={field?.testId || field?.name}
            className="height-48px"
            mode="md"
            type={field?.type as TextFieldTypes}
            aria-label="delivery"
            name={field?.name}
            onKeyPress={disableSubmitOnEnter}
            placeholder={t(`FORMS.${field?.placeholder}`) + '...'}
            // `ionChange` only fires on blur, not per keystroke - since this is a *controlled*
            // input (`value={formik.values[...]}`), any re-render that happens before blur (e.g.
            // another field's change causing this form to re-render) pushes the still-stale
            // formik value back into the DOM, visually reverting what was just typed/pasted. Using
            // `ionInput` (fires immediately) keeps formik's value in sync with every keystroke, so
            // there's no stale value left to reassert.
            onIonInput={formik?.handleChange}
            value={formik?.values?.[field?.name]}
            maxlength={field?.maxLength}
          />
        </IonItem>
      </div>
    </div>
  );
};
